import AreaAdjuster from './area-adjuster'
import LineAdjuster from './line-adjuster'

/*
 * Handles adjusting the paths of line and area charts
 */
class Adjuster {

  constructor (options) {
    this.areaAdjuster = new AreaAdjuster(options)
    this.lineAdjuster = new LineAdjuster(options)
  }

  insertSubPaths (selection, initialOffset, scalers) {
    this.lineAdjuster.insertSubPaths(selection, initialOffset, scalers)
  }

  rebind (context, points) {
    let selection = context.selection ? context.selection() : context
      , type = selection.datum().type

    this.lineAdjuster.rebind(context, points)
    if (type === 'area') {
      context.selectAll('path.line:not(.data-line)').remove()
      this.areaAdjuster.rebind(context, points)
    }
  }

  updatePathWithPoints (selection, points) {
    this.lineAdjuster.updatePathWithPoints(selection, points)
    this.areaAdjuster.updatePathWithPoints(selection, points)
  }

  transitionPaths (points, selection, merged, xScale0, xScale1) {
    this.lineAdjuster.transitionPaths(points, selection, merged, xScale0, xScale1)
    this.areaAdjuster.transitionPaths(points, selection, merged, xScale0, xScale1)
  }

  transitionPathTo (points, merged, xScale, yScale) {
    this.lineAdjuster.transitionPathTo(points, merged, xScale, yScale)
    this.areaAdjuster.transitionPathTo(points, merged, xScale, yScale)
  }

  insert (selection, scalers) {
    let type = selection.datum().type

    this.lineAdjuster.insert(selection, scalers)
    if (type === 'area') {
      selection.selectAll('path.line:not(.data-line)').remove()
      this.areaAdjuster.insert(selection, scalers)
    }
  }

  updateDrawing (selection, Curve, scalers, accessors) {
    this.lineAdjuster.updateDrawing(selection, Curve, scalers, accessors)
    this.areaAdjuster.updateDrawing(selection, Curve, scalers, accessors)
  }

}

export default Adjuster
